import { isListedMarket } from '@/utils/market-list-status.js';
import { isMarketResolved, parseMarketOutcomes } from '@/utils/market-outcomes';

export const FEED_CARD_PRICE_MAX_COLLECTIONS = 32;

/** Previews carry server-projected probabilities, never executable trade quotes. */
export function collectFeedCardPriceRequests(rows) {
  const requests = [];
  const seen = new Set();
  for (const row of Array.isArray(rows) ? rows : []) {
    if (row?.marketPreview !== true) continue;
    const collectionId = String(row.id ?? '');
    if (!/^\d+$/.test(collectionId) || seen.has(collectionId)) continue;
    const marketIds = [
      ...new Set(
        (row.markets || [])
          .filter((market) => isListedMarket(market) && !isMarketResolved(market, row))
          .map((market) => String(market.id ?? ''))
          .filter((id) => /^\d+$/.test(id))
      ),
    ].slice(0, 2);
    if (!marketIds.length) continue;
    seen.add(collectionId);
    requests.push({ collectionId, marketIds });
  }
  return requests;
}

/** Apply only requested, still-visible IDs. Never normalize the partial set. */
export function applyFeedCardPrices(rows, response, requests) {
  const data = Array.isArray(response) ? response : response?.data;
  if (!Array.isArray(data)) return false;
  const requested = new Map(requests.map((item) => [item.collectionId, new Set(item.marketIds)]));
  const prices = new Map();
  for (const item of data) {
    const collId = String(item?.collectionId ?? '');
    const marketId = String(item?.marketId ?? '');
    if (!requested.get(collId)?.has(marketId)) continue;
    try {
      const values = JSON.parse(item.outcomePrices);
      if (!Array.isArray(values) || values.length < 2) continue;
      if (
        values.some(
          (v) =>
            v == null || v === '' || !Number.isFinite(Number(v)) || Number(v) < 0 || Number(v) > 1
        )
      )
        continue;
      prices.set(`${collId}:${marketId}`, { raw: item.outcomePrices, count: values.length });
    } catch {
      // An invalid optional refresh must not discard the last displayed quote.
    }
  }
  let changed = false;
  for (const row of Array.isArray(rows) ? rows : []) {
    if (row?.marketPreview !== true) continue;
    for (const market of row.markets || []) {
      if (!isListedMarket(market) || isMarketResolved(market, row)) continue;
      const value = prices.get(`${row.id}:${market.id}`);
      if (!value || value.count !== parseMarketOutcomes(market.outcomes).length) continue;
      if (market.outcomePrices !== value.raw) {
        market.outcomePrices = value.raw;
        changed = true;
      }
    }
  }
  return changed;
}
